import {
  checkbox_styles_default
} from "./chunk.7MHKMUQW.js";
import {
  SlCheckbox
} from "./chunk.2AH6QQO3.js";
import {
  l as l2
} from "./chunk.SQVLNLTX.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/checkbox/checkbox.ts
var FadvCheckbox = class extends SlCheckbox {
  constructor() {
    super(...arguments);
    this.hasSlot = new HasSlotController(this, "link");
  }
  renderChecked() {
    if (!this.checked)
      return w;
    return $`<span part="checked-icon" class="checkbox__icon"><fadv-icon library="solid" name="check"></fadv-icon></span>`;
  }
  renderIndeterminate() {
    if (this.checked)
      return w;
    if (!this.indeterminate)
      return w;
    return $`<span part="indeterminate-icon" class="checkbox__icon"><fadv-icon library="solid" name="minus"></fadv-icon></span>`;
  }
  render() {
    return $`<label part="base" class=${o({
      checkbox: true,
      "checkbox--checked": this.checked,
      "checkbox--disabled": this.disabled,
      "checkbox--focused": this["hasFocus"],
      "checkbox--indeterminate": this.indeterminate,
      "checkbox--circle": this.circle
    })} ><input class="checkbox__input" type="checkbox" name=${l(this.name)} value=${l(this.value)} .indeterminate=${l2(this.indeterminate)} .checked=${l2(this.checked)} .disabled=${this.disabled} .required=${this.required} aria-checked=${this.checked ? "true" : "false"} @click=${this.handleClick} @blur=${this.handleBlur} @focus=${this.handleFocus} /><span part="control" class="checkbox__control">${this.renderChecked()}${this.renderIndeterminate()}</span><span part="label" class="checkbox__label"><fadv-typography type="label-x-small"><slot></slot></fadv-typography></span></label><span class=${o({
      "checkbox-link": true,
      "checkbox-link--has-link": this.hasSlot.test("link")
    })} ><fadv-typography type="label-x-small"><slot name="link"></slot></fadv-typography></span>`;
  }
};
FadvCheckbox.styles = checkbox_styles_default;
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvCheckbox.prototype, "circle", 2);
FadvCheckbox = __decorateClass([
  n("fadv-checkbox")
], FadvCheckbox);

export {
  FadvCheckbox
};
